// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'             // element-ui的css样式

import '@assets/font/iconfont.css'                        // 字体图标PC
import './assets/css/common.css'                          // 公共CSS
import './assets/css/width.scss'                          // 公共CSS
import 'animate.css'
import './assets/css/transition.css'                      // 自定义动画css
import beforeEach from './router/route-hook/beforeEach'   // 引入路由钩子跳转前公共函数
import afterEach from './router/route-hook/afterEach'     // 引入路由钩子跳转后公共函数
import $utils from '@assets/utils'                        // 公共自定义钩子函数
import * as $api from '@assets/api'                       // api请求函数
import getCommon from '@assets/api/js/common'             // 公共的缓存请求
import i18n from './i18n'                                 // 国际化
import store from './store'
import $constant from '@assets/js/constant.js'

import Viewer from 'v-viewer'                             // 图片预览
import 'viewerjs/dist/viewer.css'
import infiniteScroll from 'vue-infinite-scroll'          // 无线滚动

import elementJs from '@assets/utils/elementJs'           // 自定义引入element-ui
import BloomPlugins from './plugin/index'                 // 引入公共插件
import htmlToPdf from '@assets/utils/pdfHtml'             // html转pdf

import LeonInstruction from './instruction'               // 引入公共指令
import vFilter from './filters'                           // 引入公共过滤器
import myMixin from './mixin/common'                      // 引入公共混淆
import Popup from './components/popup/index'
import { Image } from 'element-ui'
import Bus from './bus/bus'                                 // 事件总线
import emoji from './assets/js/emoji'                   // emoji过滤
import VueAnimateOnScroll from './assets/js/vue-animate-onscroll'                   // emoji过滤
import VueCountryIntl from 'vue-country-intl'
// 引入css
import 'vue-country-intl/lib/vue-country-intl.css'
// 全局注册组件

import VueAnimateNumber from 'vue-animate-number'
Vue.component(VueCountryIntl.name, VueCountryIntl)
Vue.use(VueAnimateNumber)
// import VueAnimateOnScroll from 'vue-animate-onscroll'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper) /* { default global options } */
// Vue.use(VueAnimateOnScroll)
// import VueAnimateOnScroll from 'vue-animate-onscroll'
Vue.use(VueAnimateOnScroll)
Vue.directive('emoji', emoji)
// Vue.use(ScrollNumber)
Vue.use(LeonInstruction)                                  // 引入自定义指令
Vue.use(htmlToPdf)
Vue.use(Image)
Vue.use(Viewer)
Vue.use(infiniteScroll)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': false, 'navbar': false, 'title': false, 'toolbar': false, 'tooltip': false, 'movable': false, 'zoomable': false, 'rotatable': false, 'scalable': false, 'transition': false, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.filter('imageFormat', (val) => {
  // return `${val}?x-oss-process=image/format,jpg/quality,q_70`
  return `${val}?x-oss-process=image/format,jpg/quality,q_70`
})
Vue.prototype.$utils = $utils
Vue.prototype.$constant = $constant
Vue.prototype.$api = $api
Vue.prototype.$getCommon = getCommon
Vue.prototype.$popup = Popup.install
Vue.prototype.$bus = Bus

elementJs()                                               // 自定义引入element-ui
Vue.use(vFilter)                                          // 引入公共过滤器
Vue.use(BloomPlugins)                                     // 自定义ui插件
Vue.use(myMixin)                                          // 公共混淆

router.beforeEach((to, from, next) => { // 跳转路由前公共钩子函数
  beforeEach(to, from, next)
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  console.log(1111, isChunkLoadFailed)
  if (isChunkLoadFailed) {
    console.log(222222)
    window.location.reload()
  } else {
    console.log(error)
  }
})

router.afterEach((to, from, next) => {  // 跳转路由后公共钩子函数
  afterEach(to, from, next)
})
Vue.config.productionTip = false

const vm = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>'
})

export default vm



// WEBPACK FOOTER //
// ./src/main.js